import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Transfer } from '../Transfer';
import ResourceListPage from '../ResourceList';
import ResourceCreatePage from '../ResourceList/ResourceCreate';
import ClientsListPage from '../Clients';
import ClientDetails from '../Clients/ClientDetails';
import { Login } from '../Auth';
import HomeContent from '../Home/HomeContent';
import Reports from '../Reports';
import AccountUsersPage from '../Reports/AccountUsers';
import Categories from '../Categories/Categories';
import CategoryCreatePage from '../Categories/Category';
import ResourcePdfViewer from '../ResourceList/ResourcePdfViewer';


export const ConsoleRoutes = () => {
	return (
		<Routes>
			<Route
				path="clients"
				element={
					<ProtectedRoute>
						<ClientsListPage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="clients/edit/:clientId"
				element={
					<ProtectedRoute>
						<ClientDetails />
					</ProtectedRoute>
				}
			/>

			<Route
				path="categories"
				element={
					<ProtectedRoute>
						<Categories />
					</ProtectedRoute>
				}
			/>

			<Route
				path="categories/create"
				element={
					<ProtectedRoute>
						<CategoryCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="categories/edit/:categoryId"
				element={
					<ProtectedRoute>
						<CategoryCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources"
				element={
					<ProtectedRoute>
						<ResourceListPage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/edit/:resourceId"
				element={
					<ProtectedRoute>
						<ResourceCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/create"
				element={
					<ProtectedRoute>
						<ResourceCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/edit/:resourceId/pdf/:pdfId"
				element={
					<ProtectedRoute>
						<ResourcePdfViewer />
					</ProtectedRoute>
				}
			/>

			<Route
				path="reports"
				element={
					<ProtectedRoute>
						<Reports />
					</ProtectedRoute>
				}
			/>

			<Route
				path="reports/account-users"
				element={
					<ProtectedRoute>
						<AccountUsersPage />
					</ProtectedRoute>
				}
			/>

			<Route path="login" element={<Login />} />
			<Route path="/" element={<HomeContent />} />
		</Routes>
	);
};

const ProtectedRoute = ({ children }) => {
	if (!window.sessionStorage.getItem('accessToken')) {
		return <Navigate to="blank" />;
	}
	return children;
};
